<template>
    <div v-if="show">
        Mention me
    </div>
</template>

<script>
export default {
    name: 'Mention',
    props: {
        value: {
            type: String
        }
    },

    data: function() {
        return {
            show: false
        }
    },

    watch: {
        value: function(n) {
            const reg = new RegExp('@([1-9]|[aA-zZ])+', 'g')
            if (reg.test(n)) {
                this.show = true
            } else {
                this.show = false
            }
        }
    },

    mounted() {

    }
}
</script>